import React from 'react';
import { createRoot } from 'react-dom/client';

import en from './i18n/en';
import * as i18n from '../common/i18n';

import Login from './components/login';

i18n.initialize({ 
  debug: process.env.NODE_ENV === 'development', // eslint-disable-line no-undef
  defaultNS: 'login',
  resources: { en },
}).then(() => {
  createRoot(document.getElementById('entry')).render(<Login />);
});
